const useStyles = () => {
    return {
        container: {
            width: '100%',
            display: 'flex',
            flexWrap: 'wrap'
        },
        itemInfo: {
            flex: '1 0 400px'
        },
        item: {
            display: 'flex',
            alignItems: 'end',
            justifyContent: 'space-between',
            gap: 2,
            '& .MuiTypography-root': {
                flex: 1
            },
        }
    }
}

export { useStyles }